import { render, staticRenderFns } from "./pupuGoods.vue?vue&type=template&id=f584fcfa&"
import script from "./pupuGoods.vue?vue&type=script&lang=js&"
export * from "./pupuGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports